import { Extension } from '@tiptap/core';

export const LINE_HEIGHTS = ['1', '1.15', '1.5', '2', '2.5'];
export const DEFAULT_LINE_HEIGHT = '1.5';

export const LineHeight = Extension.create({
	name: 'lineHeight',
	addOptions() {
		return {
			types: ['paragraph', 'heading'],
			defaultLineHeight: DEFAULT_LINE_HEIGHT,
		};
	},

	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					lineHeight: {
						default: this.options.defaultLineHeight,
						keepOnSplit: true,
						parseHTML: (element) =>
							element.style.lineHeight || this.options.defaultLineHeight,
						renderHTML: (attributes) => {
							const lineHeight =
								attributes.lineHeight || this.options.defaultLineHeight;
							return { style: `line-height: ${lineHeight}` };
						},
					},
				},
			},
		];
	},

	addCommands() {
		return {
			setLineHeight:
				(lineHeight) =>
				({ tr, state, dispatch }) => {
					let updated = false;

					state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos) => {
						if (!this.options.types.includes(node.type.name)) return;
						updated = true;
						if (dispatch) {
							tr.setNodeMarkup(pos, undefined, { ...node.attrs, lineHeight });
						}
					});

					return updated;
				},
		};
	},
});

export default LineHeight;
